<style lang="postcss">
	.file-icon-cover {
		font-size: 10px;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
	}
</style>

<script lang="ts">
	export let mime: string | undefined = undefined;

	let mimeType = "";
	$: mimeType = mime ? mime.split(";")[0] : "";

	const audioMimes = [
		"audio/basic",
		"audio/L24",
		"audio/mp4",
		"audio/mpeg",
		"audio/ogg",
		"audio/vorbis",
		"audio/vnd.rn-realaudio",
		"audio/vnd.wave",
		"audio/webm",
		"audio/wav",
		"audio/x-aiff",
		"audio/x-mpegurl",
		"audio/x-ms-wma",
		"audio/x-pn-realaudio",
		"audio/x-pn-realaudio-plugin",
		"audio/x-wav"
	];
	const archiveMimes = [
		"application/zip",
		"application/x-rar-compressed",
		"application/x-tar",
		"application/x-7z-compressed",
		"application/x-apple-diskimage",
		"application/x-bzip",
		"application/x-bzip2",
		"application/x-gzip",
		"application/x-lzip",
		"application/x-lzma",
		"application/x-lzop",
		"application/x-rar",
		"application/x-tar",
		"application/x-xz",
		"application/x-zstd"
	];
	const videoMimes = [
		"video/mpeg",
		"video/mp4",
		"video/ogg",
		"video/quicktime",
		"video/webm",
		"video/x-ms-wmv",
		"video/x-flv",
		"video/x-msvideo",
		"video/x-ms-asf"
	];
	const codeMimes = [
		"text/css",
		"text/csv",
		"text/html",
		"text/javascript",
		"text/plain",
		"text/xml",
		"text/x-markdown",
		"text/x-vcard",
		"text/yaml",
		"text/calendar",
		"text/vnd.curl",
		"text/vnd.curl.dcurl",
		"text/vnd.curl.mcurl",
		"text/vnd.curl.scurl",
		"text/svelte",
		"text/jsx"
	];
	const imageMimes = [
		"image/gif",
		"image/jpeg",
		"image/pjpeg",
		"image/png",
		"image/svg+xml",
		"image/tiff",
		"image/vnd.microsoft.icon",
		"image/vnd.wap.wbmp",
		"image/webp"
	];
	const pdfMimes = ["application/pdf"];
	const documentMimes = [
		"application/pdf",
		"application/msword",
		"application/vnd.openxmlformats-officedocument.wordprocessingml.document",
		"application/rtf",
		"application/vnd.ms-excel",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
		"application/vnd.ms-powerpoint",
		"application/vnd.openxmlformats-officedocument.presentationml.presentation"
	];
</script>

<div class="{$$props.class ?? ''} file-icon-cover">
	{#if typeof mimeType === "undefined"}
		File
	{:else if audioMimes.includes(mimeType)}
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="18"
			height="18"
			fill="currentColor"
			viewBox="0 0 256 256"
			><path
				d="M128,176a48.05,48.05,0,0,0,48-48V64a48,48,0,0,0-96,0v64A48.05,48.05,0,0,0,128,176ZM96,64a32,32,0,0,1,64,0v64a32,32,0,0,1-64,0Zm40,143.6V232a8,8,0,0,1-16,0V207.6A80.11,80.11,0,0,1,48,128a8,8,0,0,1,16,0,64,64,0,0,0,128,0,8,8,0,0,1,16,0A80.11,80.11,0,0,1,136,207.6Z"
			></path
			></svg>
		Audio
	{:else if imageMimes.includes(mimeType)}
		Image
	{:else if videoMimes.includes(mimeType)}
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			width="18"
			height="18"
			viewBox="0 0 24 24"
			stroke-width="1.5"
			stroke="currentColor">
			<path
				stroke-linecap="round"
				d="M15.75 10.5l4.72-4.72a.75.75 0 011.28.53v11.38a.75.75 0 01-1.28.53l-4.72-4.72M4.5 18.75h9a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25h-9A2.25 2.25 0 002.25 7.5v9a2.25 2.25 0 002.25 2.25z"
			></path>
		</svg>

		Video
	{:else if archiveMimes.includes(mimeType)}
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			width="18"
			height="18"
			viewBox="0 0 24 24"
			stroke-width="1.5"
			stroke="currentColor">
			<path
				stroke-linecap="round"
				stroke-linejoin="round"
				d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5M10 11.25h4M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"
			></path>
		</svg>
		Archive
	{:else if codeMimes.includes(mimeType)}
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke-width="1.5"
			width="18"
			height="18"
			stroke="currentColor">
			<path
				stroke-linecap="round"
				stroke-linejoin="round"
				d="M14.25 9.75L16.5 12l-2.25 2.25m-4.5 0L7.5 12l2.25-2.25M6 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v12A2.25 2.25 0 006 20.25z"
			></path>
		</svg>

		Code
	{:else if pdfMimes.includes(mimeType)}
		PDF
	{:else if documentMimes.includes(mimeType)}
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="18"
			height="18"
			fill="currentColor"
			viewBox="0 0 256 256"
			><path
				d="M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM40,72H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16ZM216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"
			></path
			></svg>
		Doc
	{:else}
		File
	{/if}
</div>
